module.exports = __webpack_public_path__ + "media/images/stock_groups/e57a-48385d810c3ada8a0b14fccf4e723abc.svg";